<template>
  <section class="warranty" id="start">
    <div class="container">

      <!-- Header -->
      <div class="warranty-header">
        <div class="badge">
          <i class="bi bi-shield-fill-check"></i>
          Políticas de Garantía
        </div>
        <h1 class="warranty-title">Políticas de Garantía<br />GST</h1>
        <p class="warranty-meta">
          <i class="bi bi-building"></i> OPERACION SISTEMICA SAS
          <span class="dot">·</span>
          <i class="bi bi-envelope-fill"></i> soporte@gst.com.co
          <span class="dot">·</span>
          <i class="bi bi-telephone-fill"></i> +57 301 573 9461
          <span class="dot">·</span>
          <i class="bi bi-calendar3"></i> Última actualización: Marzo 2026
        </p>
        <p class="warranty-intro">
          Las presentes políticas regulan los términos bajo los cuales <strong>OPERACION SISTEMICA SAS</strong>
          reconoce o limita la responsabilidad frente al funcionamiento de la plataforma GST y los
          servicios contratados. Al adquirir cualquier plan o servicio, el cliente acepta expresamente
          estas condiciones.
        </p>
      </div>

      <div class="sections">

        <!-- 1. Exclusiones -->
        <div class="section-card">
          <div class="section-icon"><i class="bi bi-slash-circle-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">1. Exclusiones de Garantía</h2>
            <p>No se reconocerá garantía en los siguientes casos:</p>
            <ul class="exclusion-list">
              <li><i class="bi bi-x-circle-fill"></i><span><strong>Uso indebido:</strong> uso de la plataforma para fines distintos a los previstos o en contra de las instrucciones.</span></li>
              <li><i class="bi bi-x-circle-fill"></i><span><strong>Manipulación no autorizada:</strong> modificaciones, integraciones o accesos no autorizados.</span></li>
              <li><i class="bi bi-x-circle-fill"></i><span><strong>Infraestructura del cliente:</strong> fallas en conexión a internet, equipos, servidores locales u otros componentes bajo responsabilidad del cliente.</span></li>
              <li><i class="bi bi-x-circle-fill"></i><span><strong>Factores externos:</strong> fuerza mayor, ataques cibernéticos, desastres naturales, cortes de energía o circunstancias ajenas a OPERACION SISTEMICA SAS.</span></li>
              <li><i class="bi bi-x-circle-fill"></i><span><strong>Pérdida de datos:</strong> por falta de respaldo por parte del cliente o eliminación accidental no atribuible a fallos de la plataforma.</span></li>
              <li><i class="bi bi-x-circle-fill"></i><span><strong>Suspensión por falta de pago:</strong> la suspensión por mora no da lugar a garantía ni compensación.</span></li>
            </ul>
          </div>
        </div>

        <!-- 2. Condiciones por tipo -->
        <div class="section-card">
          <div class="section-icon"><i class="bi bi-layers-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">2. Condiciones por Tipo de Servicio</h2>

            <div class="subsection">
              <h3 class="subsection-title"><i class="bi bi-cloud-check-fill"></i> 2.1 Planes de Suscripción (SaaS)</h3>
              <p>Todos los clientes tienen cobertura sobre el funcionamiento normal de la plataforma conforme a las especificaciones técnicas publicadas. La garantía aplica únicamente por defectos imputables a la plataforma: errores de software, caídas no programadas o fallos en funcionalidades contratadas.</p>
              <div class="sub-cards">
                <div class="sub-card">
                  <i class="bi bi-person-badge-fill"></i>
                  <div>
                    <strong>Técnicos / Usuarios profesionales</strong>
                    <p>Cobertura durante todo el período de suscripción activa, siempre que el cliente esté al día en sus pagos.</p>
                  </div>
                </div>
                <div class="sub-card">
                  <i class="bi bi-clock-history"></i>
                  <div>
                    <strong>Período de prueba gratuito</strong>
                    <p>La plataforma se ofrece "tal cual", con responsabilidad limitada a fallos críticos que impidan completamente la evaluación del servicio.</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="subsection">
              <h3 class="subsection-title"><i class="bi bi-hdd-fill"></i> 2.2 Almacenamiento Adicional</h3>
              <p>La garantía cubre la disponibilidad del espacio y la integridad de los datos, siempre que el cliente esté al día en pagos y haya realizado sus propios respaldos. No aplica por:</p>
              <ul class="exclusion-list">
                <li><i class="bi bi-x-circle-fill"></i> Pérdida de datos por falta de pago</li>
                <li><i class="bi bi-x-circle-fill"></i> Datos eliminados voluntariamente por el cliente</li>
                <li><i class="bi bi-x-circle-fill"></i> Información dañada por virus o malware ingresado desde equipos del cliente</li>
              </ul>
            </div>

            <div class="subsection">
              <h3 class="subsection-title"><i class="bi bi-headset"></i> 2.3 Soporte Técnico Incluido</h3>
              <p>Todos los planes incluyen soporte sobre el funcionamiento de la plataforma. La garantía <strong>no cubre</strong>:</p>
              <ul class="exclusion-list">
                <li><i class="bi bi-x-circle-fill"></i> Capacitación o entrenamiento no contratado expresamente</li>
                <li><i class="bi bi-x-circle-fill"></i> Asesoría sobre procesos internos del negocio del cliente</li>
                <li><i class="bi bi-x-circle-fill"></i> Configuraciones que excedan las funcionalidades estándar</li>
                <li><i class="bi bi-x-circle-fill"></i> Integraciones con sistemas externos no contempladas en el plan</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 3. Procedimiento -->
        <div class="section-card">
          <div class="section-icon"><i class="bi bi-diagram-3-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">3. Procedimiento para la Reclamación</h2>
            <p>Toda solicitud debe presentarse a través de los canales oficiales:</p>
            <div class="channels">
              <a href="mailto:soporte@gst.com.co" class="channel-pill"><i class="bi bi-envelope-fill"></i> soporte@gst.com.co</a>
              <a href="https://wa.me/573015739461" class="channel-pill"><i class="bi bi-whatsapp"></i> +57 301 573 9461</a>
              <a href="https://ayuda.gst.com.co" class="channel-pill"><i class="bi bi-life-preserver"></i> ayuda.gst.com.co</a>
            </div>

            <p class="mt">El cliente deberá aportar:</p>
            <ul class="check-list">
              <li><i class="bi bi-check-circle-fill"></i> Número de factura o referencia del pago</li>
              <li><i class="bi bi-check-circle-fill"></i> Descripción detallada de la falla presentada</li>
              <li><i class="bi bi-check-circle-fill"></i> Evidencias: capturas de pantalla, videos o registros de error</li>
            </ul>

            <div class="steps">
              <div class="step">
                <div class="step-num">1</div>
                <div class="step-body">
                  <strong>Recepción</strong>
                  <p>El equipo técnico recibe y registra la solicitud por los canales oficiales.</p>
                </div>
              </div>
              <div class="step">
                <div class="step-num">2</div>
                <div class="step-body">
                  <strong>Revisión</strong>
                  <p>Se determina si la falla es imputable a la plataforma. La revisión se realiza vía chat o correo; solo en casos necesarios y con autorización expresa se podrá solicitar acceso remoto.</p>
                </div>
              </div>
              <div class="step">
                <div class="step-num">3</div>
                <div class="step-body">
                  <strong>Resolución</strong>
                  <p>Si procede la garantía, se corrige dentro de los plazos según la criticidad. Si no procede, se informa al cliente con la justificación técnica correspondiente.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 4. Limitación -->
        <div class="section-card">
          <div class="section-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">4. Limitación de Responsabilidad</h2>
            <p>OPERACION SISTEMICA SAS no será responsable por daños indirectos, incidentales, especiales, consecuenciales o punitivos, incluyendo:</p>
            <ul class="exclusion-list">
              <li><i class="bi bi-x-circle-fill"></i> Pérdida de beneficios, datos, uso o buena voluntad</li>
              <li><i class="bi bi-x-circle-fill"></i> Interrupción del negocio del cliente</li>
              <li><i class="bi bi-x-circle-fill"></i> Pérdida de información por falta de respaldo por parte del cliente</li>
              <li><i class="bi bi-x-circle-fill"></i> Daños derivados del uso o imposibilidad de uso de la plataforma</li>
            </ul>
            <div class="limit-note">
              <i class="bi bi-info-circle-fill"></i>
              <p>La responsabilidad máxima de OPERACION SISTEMICA SAS en ningún caso excederá el valor pagado por el cliente durante el <strong>mes inmediatamente anterior</strong> a la fecha en que se originó la reclamación.</p>
            </div>
          </div>
        </div>

        <!-- 5. Vigencia -->
        <div class="section-card section-card--last">
          <div class="section-icon"><i class="bi bi-calendar-check-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">5. Vigencia</h2>
            <p>
              Estas políticas entran en vigencia a partir de su publicación y aplican para todas las
              suscripciones y servicios contratados a través de la plataforma
              <strong>GST – Gestión Servicio Técnico</strong>.
            </p>
          </div>
        </div>

      </div>

      <!-- Contact CTA -->
      <div class="contact-cta">
        <i class="bi bi-headset"></i>
        <div>
          <strong>¿Necesitas presentar una reclamación de garantía?</strong>
          <p>Contáctanos en <a href="mailto:soporte@gst.com.co">soporte@gst.com.co</a>, al <a href="tel:+573015739461">+57 301 573 9461</a> o visita <a href="https://ayuda.gst.com.co">ayuda.gst.com.co</a>.</p>
        </div>
      </div>

      <!-- Footer note -->
      <div class="warranty-footer">
        <i class="bi bi-building"></i>
        <span>OPERACION SISTEMICA SAS · NIT 901227220-8 · © 2019–2026 GST. Todos los derechos reservados.</span>
      </div>

    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue'
import { useRoute } from 'vue-router'

defineProps({ darkMode: Boolean })

const route = useRoute()

import { onMounted, nextTick } from 'vue'
onMounted(() => {
  nextTick(() => {
    if (route.hash) {
      const id = route.hash.replace('#', '')
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ block: 'start' })
      }
    }
  })
})
</script>

<style scoped>
.warranty {
  min-height: 100vh;
  background: var(--bg);
  padding: 5rem 0 4rem;
  transition: background 0.35s;
}

.container {
  max-width: 860px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

/* ══ HEADER ══ */
.warranty-header {
  text-align: center;
  margin-bottom: 3rem;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  color: var(--accent);
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.35rem 0.9rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
}

.warranty-title {
  font-size: clamp(1.8rem, 4vw, 3rem);
  font-weight: 900;
  letter-spacing: -0.04em;
  line-height: 1.15;
  color: var(--text);
  margin-bottom: 1rem;
  transition: color 0.35s;
}

.warranty-meta {
  font-size: 0.85rem;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  transition: color 0.35s;
}

.warranty-meta i { color: var(--accent); }
.dot { opacity: 0.4; }

.warranty-intro {
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.7;
  max-width: 640px;
  margin: 0 auto;
  background: var(--bg-card);
  border: 1px solid var(--border-soft);
  border-radius: 1rem;
  padding: 1.25rem 1.5rem;
  transition: background 0.35s, border-color 0.35s, color 0.35s;
}

/* ══ SECTIONS ══ */
.sections {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 2rem;
}

.section-card {
  display: flex;
  gap: 1.5rem;
  background: var(--bg-card);
  border: 1px solid var(--border-soft);
  border-radius: 1.25rem;
  padding: 1.75rem;
  transition: background 0.35s, border-color 0.35s;
}

.section-card--last {
  border-color: var(--accent);
  box-shadow: 0 0 0 1px var(--accent), 0 4px 24px var(--accent-glow);
}

.section-icon {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: var(--accent);
  transition: background 0.35s, border-color 0.35s;
}

.section-body { flex: 1; min-width: 0; }

.section-title {
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--text);
  margin-bottom: 0.75rem;
  letter-spacing: -0.02em;
  transition: color 0.35s;
}

.section-body > p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.7;
  margin-bottom: 0.75rem;
  transition: color 0.35s;
}

/* ══ SUBSECTIONS ══ */
.subsection {
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px dashed var(--border-soft);
}

.subsection:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.subsection-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--accent);
  margin-bottom: 0.6rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.35s;
}

.subsection p {
  font-size: 0.88rem;
  color: var(--text-muted);
  line-height: 1.6;
  margin-bottom: 0.75rem;
  transition: color 0.35s;
}

.sub-cards {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.sub-card {
  display: flex;
  gap: 0.75rem;
  background: var(--bg);
  border: 1px solid var(--border-soft);
  border-radius: 0.75rem;
  padding: 0.9rem 1rem;
  transition: background 0.35s, border-color 0.35s;
}

.sub-card > i {
  color: var(--accent);
  font-size: 1.3rem;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.sub-card strong {
  display: block;
  font-size: 0.88rem;
  color: var(--text);
  margin-bottom: 0.2rem;
  transition: color 0.35s;
}

.sub-card p {
  font-size: 0.83rem;
  color: var(--text-muted);
  line-height: 1.5;
  margin: 0;
  transition: color 0.35s;
}

/* ══ CHANNELS ══ */
.channels {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-bottom: 1rem;
}

.channel-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  color: var(--accent);
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.35rem 0.85rem;
  border-radius: 9999px;
  text-decoration: none;
  transition: background 0.2s, border-color 0.2s;
}

.channel-pill:hover {
  background: var(--accent);
  color: var(--accent-text);
  border-color: var(--accent);
}

.mt { margin-top: 0.75rem !important; }

/* ══ CHECK LIST ══ */
.check-list {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.check-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.88rem;
  color: var(--text-muted);
  line-height: 1.5;
  transition: color 0.35s;
}

.check-list li i { color: var(--accent); font-size: 0.9rem; flex-shrink: 0; margin-top: 0.15rem; }

/* ══ EXCLUSION LIST ══ */
.exclusion-list {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.exclusion-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.88rem;
  color: var(--text-muted);
  line-height: 1.5;
  transition: color 0.35s;
}

.exclusion-list li i { color: #ef4444; font-size: 0.9rem; flex-shrink: 0; margin-top: 0.15rem; }
.exclusion-list li span { flex: 1; }

/* ══ STEPS ══ */
.steps {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
}

.step {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.step-num {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  background: var(--accent);
  color: var(--accent-text);
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 900;
}

.step-body strong {
  display: block;
  font-size: 0.9rem;
  color: var(--text);
  margin-bottom: 0.2rem;
  transition: color 0.35s;
}

.step-body p {
  font-size: 0.85rem;
  color: var(--text-muted);
  line-height: 1.6;
  margin: 0;
  transition: color 0.35s;
}

/* ══ LIMIT NOTE ══ */
.limit-note {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  background: var(--border-soft);
  border: 1px solid var(--border);
  border-radius: 0.75rem;
  padding: 1rem;
  margin-top: 1rem;
  transition: background 0.35s, border-color 0.35s;
}

.limit-note i { color: var(--accent); font-size: 1.1rem; flex-shrink: 0; margin-top: 0.1rem; }

.limit-note p {
  font-size: 0.88rem;
  color: var(--text-muted);
  line-height: 1.6;
  margin: 0;
  transition: color 0.35s;
}

/* ══ CONTACT CTA ══ */
.contact-cta {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
  background: var(--bg-card);
  border: 1px solid var(--accent);
  box-shadow: 0 0 0 1px var(--accent), 0 4px 24px var(--accent-glow);
  border-radius: 1.25rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.contact-cta > i { font-size: 1.8rem; color: var(--accent); flex-shrink: 0; margin-top: 0.1rem; }

.contact-cta strong {
  display: block;
  font-size: 0.95rem;
  color: var(--text);
  margin-bottom: 0.3rem;
  transition: color 0.35s;
}

.contact-cta p {
  font-size: 0.88rem;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.6;
  transition: color 0.35s;
}

.contact-cta a { color: var(--accent); font-weight: 600; text-decoration: none; }
.contact-cta a:hover { text-decoration: underline; }

/* ══ FOOTER NOTE ══ */
.warranty-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.78rem;
  color: var(--text-muted);
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-light);
  transition: color 0.35s, border-color 0.35s;
}

.warranty-footer i { color: var(--accent); }



/* ══ RESPONSIVE ══ */
@media (max-width: 640px) {
  .warranty { padding: 3rem 0 2rem; }
  .container { padding: 0 1rem; }

  .section-card, .contact-cta {
    flex-direction: column;
    gap: 1rem;
    padding: 1.25rem;
  }

  .section-card, .contact-cta { align-items: center; text-align: center; }
  .section-icon { width: 2.5rem; height: 2.5rem; font-size: 1.1rem; align-self: center; }
  .section-body { text-align: center; }
  .exclusion-list, .check-list { text-align: left; }
  .exclusion-list li, .check-list li { display: block; padding-left: 1.5rem; position: relative; }
  .exclusion-list li i, .check-list li i { position: absolute; left: 0; top: 0.2rem; }
  .subsection-title { justify-content: center; }
  .sub-card { flex-direction: column; align-items: center; text-align: center; }
  .channels { justify-content: center; }
  .steps .step { flex-direction: column; align-items: center; text-align: center; }
  .limit-note { flex-direction: column; align-items: center; text-align: center; }
  .warranty-title { font-size: clamp(1.5rem, 7vw, 1.8rem); }
  .warranty-intro { padding: 1rem; font-size: 0.88rem; }
  .warranty-meta { font-size: 0.75rem; }
  .channels { gap: 0.4rem; }
  .channel-pill { font-size: 0.76rem; }
}

/* ══ PANTALLAS GRANDES ══ */
@media (min-width: 1400px) {
  .container { max-width: 1100px; }
}

@media (min-width: 1920px) {
  .container { max-width: 1300px; }
}

@media (min-width: 2560px) {
  .container { max-width: 1600px; }
}
</style>